"use client";
import { useId } from "react";
import { consentItemUnlocked, updateConsentChoice, sensitiveInformation, type ConsentChoices } from "../consent";
export function OnboardingConsentChoices({ choices, onChoice, disabled }: { choices: ConsentChoices; onChoice: (choices: ConsentChoices) => void; disabled: boolean }) {
  const groupId = useId();
  return <>
    <h3 className="rg-section-title">敏感信息授权 · 请逐项选择</h3>
    <div className="rg-information">{sensitiveInformation.map((item, index) => <div key={item.key} className="rg-information-row rg-consent-row" data-locked={disabled || !consentItemUnlocked(choices, index)}>
      <span aria-hidden="true">{String.fromCharCode(65 + index)}</span>
      <div className="min-w-0 flex-1"><h3>{item.title}</h3><p>处理内容　{item.content}</p><p>使用用途　{item.key === "agency" ? "机构签约与授权管理" : item.purpose}</p></div>
      <fieldset disabled={disabled || !consentItemUnlocked(choices, index)} className="rg-consent-choices">
        <legend className="sr-only">{item.title}</legend>
        <label>
          <input type="checkbox" name={`${groupId}-consent-${item.key}`} value="agree" checked={choices[item.key] === "agree"} onChange={event => onChoice(updateConsentChoice(choices, item.key, event.target.checked))} />
          <span>同意</span>
        </label>
      </fieldset>
    </div>)}</div>
    {Object.values(choices).includes("disagree") && <p role="alert" className="rg-error">尚未同意必需的信息处理，暂不能继续入驻。</p>}
  </>;
}
